import { css } from "styled-components";
import * as stylesConstaints from '../../../../assets/constants/ui'

export const TABLE_HEADER_STYLED = css`
    grid-template-columns: 110px 256px 174px 1fr;
    padding: 0 30px 0 58px;
    width: calc(100% - (30px + 58px));
    height: ${stylesConstaints.TABLE_HEADER_HEIGHT}px;
    margin-bottom: 10px;
`

export const TABLE_HEADER_TITILE = [
    {
        label: 'table.header.time_wait', 
        styled: css`
            margin-left: 16px;
        `
    },
    { label: 'table.header.user_information' },
    { label: 'table.header.date_submit' },
    { label: 'table.header.status' }
]
